import axios from "axios";
import Router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import { Toast } from "vant";
import Aes256Cryto from "@/utils/aes256Encryption";

// axios.defaults.baseURL = '/api'
axios.defaults.timeout = 1000 * 60 * 3;
axios.defaults.withCredentials = true;

axios.interceptors.request.use(
    config => {
        if (config.url && config.url.includes('/dex-api/')) {
            config.headers["Content-Type"] = "application/json;charset=utf-8";
        } else if (!config.headers["Content-Type"]) {
            config.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=utf-8";
        }
        config.headers["language"] = i18n.locale;
        config.headers["token"] = store.state.token || '';
        config.headers["ip"] = store.state.ip || ''; 
        if (process.env.VUE_APP_BUILD_TARGET === 'app' && config.url) {
            const routes = [
                ['/api-news/', process.env.VUE_APP_BASE_URL_NEWS || ''],
                ['/api-user/', (process.env.VUE_APP_BASE_URL_USER || '') + '/api'],
                ['/dex-api/', process.env.VUE_APP_BASE_URL_DEX || '/dex-api'],
            ];
            const route = routes.find(([prefix]) => config.url.startsWith(prefix));
            if (route) {
                config.url = route[1].replace(/\/$/, '') + '/' + config.url.slice(route[0].length);
            }
        }

        return config;
    },
    error => {
        console.log(`err${error}`);
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    res => {
        if (res.data.code == 5) {
            setTimeout(() => {
                store.commit('QUIT');
                Router.push('/login');
            }, 2000);
        }
        if (res.data.code != 0) {
            Toast.fail(res.data.code == 5 ? i18n.t("content.sessionExpired") : (res.data.msg || i18n.t("content.requestFailed")));
            return Promise.reject(res.data.msg);
        } else {
            if (res.data.data && res.data.data.token && !res.request.responseURL.includes('/get-wallet-balance')) {
                store.commit('SET_TOKEN', res.data.data.token)
            }
            const type = typeof res.data.data;
            if (type === 'string' && res.data.data) {
                try {
                    res.data.data = JSON.parse(Aes256Cryto.Decrypt(res.data.data));
                } catch (e) {
                    console.error('Decrypt error:', e);
                }
            }
            return res.data;
        }
    },
    error => {
        Toast.fail(i18n.t(error.code === "ECONNABORTED" || error.code === "ETIMEDOUT" ? "content.timeout" : !error.response ? "content.networkError" : "content.requestFailed"));
        return Promise.reject(error);
    }
)

export default axios;
